module.exports = __webpack_public_path__ + "static/media/998157.745883ca.jpg";